module.exports = __webpack_public_path__ + "media/assets/NewCalendar-932859ee1f7d394dc28fd05ce9e4ed4b.svg";